<template>
  <button
    class="hamburger"
    type="button"
    :class="{ active: drawerOpen }"
    :aria-expanded="drawerOpen ? 'true' : 'false'"
    :aria-label="drawerOpen ? 'Close navigation menu' : 'Open navigation menu'"
    @click.prevent="handleClick"
  >
    <span></span>
  </button>
</template>

<script lang="js">
import {mapState} from "vuex";

export default {
  name: 'ahc-hamburger',
  props: {
    callback: {
      type: Function,
    },
    text: {
      type: String,
      default: 'Open navigation menu',
    },
  },
  computed: mapState(['drawerOpen']),
  watch: {
    /**
     * If the nav is triggered open by something else,
     * make the hamburger active as well
     * @param {boolean} newValue
     */
    drawerOpen(newValue) {
      if(!newValue) {
        // if the drawer is now closed, make sure focus is on
        // the hamburger, in case it was triggered by something else
        const scrollY = window.pageYOffset;
        this.$el.focus();
        window.scrollTo(0, scrollY);
      }
    }
  },
  methods: {
    /**
     * On click, toggle active state and update $store
     */
    handleClick() {
      this.$store.commit('setDrawerOpen', !this.drawerOpen)
    }
  },
}
</script>
